module.exports = __webpack_public_path__ + "static/ABC_logo-ab46412b125aebc1af1ad088bea770f7.png";